/**
 * The fetchCashWallet (GET /wallet) query key, per signed-in user (review of
 * the make-good credits, 2026-10-28): signing out does not reset the query
 * cache, so a driver who signs in after another on the same device must never
 * read the other's cached balance or make-good credits, which would default
 * their first start to the other driver's credit. Every page that reads the
 * wallet shares this key; invalidating ['wallet'] still reaches it.
 */
export const cashWalletQueryKey = (userId: string | null | undefined) => ['wallet', 'cash', userId ?? null] as const;
